export default "{\n    \"defaultMessage\": \"Oups... quelque chose s'est mal passé\",\n    \"retryButtonLabel\": \"Réessayer\"\n}\n"